export default class TextAreaControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.textarea = document.createElement('textarea')
    this.textarea.id = window.PRIM.getUUID()
    this.textarea.value = args.value ? args.value : ''
    this.textarea.rows = 8
    this.textarea.autocapitalize = 'sentences'
    this.textarea.autocorrect = 'on'
    this.textarea.spellcheck = 'true'
    this.textarea.disabled = args.readonly ? 'disabled' : ''
    this.textarea.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.textarea.id
    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.textarea)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.textarea.value ? this.textarea.value : null
  }

  setValue (value) {
    this.textarea.value = value
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/TextAreaControl.js